export default __webpack_public_path__ + "img/img_claire-4ac7e8d6e5df12bf37df7877bc3a0343.png";